import { clsx } from 'clsx';
import styles from './EventTimeline.module.css';

export interface TimelineEvent {
  id: string;
  time: string;
  title: string;
  description?: string;
  type?: 'event' | 'observation' | 'decision' | 'falsifier';
  active?: boolean;
}

export function EventTimeline({
  events,
  onSelect,
}: {
  events: TimelineEvent[];
  onSelect?: (event: TimelineEvent) => void;
}) {
  return (
    <ol className={styles.root}>
      {events.map((event) => (
        <li
          key={event.id}
          className={clsx(
            styles.item,
            event.type === 'decision' && styles.decision,
            event.type === 'falsifier' && styles.falsifier,
            event.active && styles.active,
          )}
        >
          <button
            type="button"
            className={styles.button}
            onClick={() => onSelect?.(event)}
          >
            <time className={styles.time}>{event.time}</time>
            <strong className={styles.title}>{event.title}</strong>
            {event.description && (
              <span className={styles.description}>{event.description}</span>
            )}
          </button>
        </li>
      ))}
    </ol>
  );
}
